import { useQuery } from "@tanstack/react-query";
import { invoiceService } from "../../services/proposals";
import Table from "../common/Table";
import Button from "../common/Button";
import { format } from "date-fns";
import { Download } from "lucide-react";
import toast from "react-hot-toast";

const InvoiceList = ({ onEdit, onDelete }) => {
  const { data: invoices, isLoading } = useQuery({
    queryKey: ["invoices"],
    queryFn: invoiceService.getAll,
  });

  const columns = [
    { header: "Invoice Number", accessor: "invoiceNumber" },
    { header: "Client", accessor: (row) => row.client?.name },
    { header: "Total", accessor: (row) => `₹${row.total}` },
    {
      header: "Due Date",
      accessor: (row) =>
        row.dueDate ? format(new Date(row.dueDate), "dd MMM yyyy") : "-",
    },
    { header: "Status", accessor: "status" },
    { header: "Paid Amount", accessor: (row) => `₹${row.paidAmount || 0}` },
  ];

  const handleDownloadPDF = async (id) => {
    try {
      const blob = await invoiceService.downloadPDF(id);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `invoice-${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {
      toast.error("Failed to download PDF");
    }
  };

  const actions = (row) => (
    <>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => handleDownloadPDF(row._id)}
      >
        <Download size={14} className="inline mr-1" />
        PDF
      </Button>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => onEdit(row)}
      >
        Edit
      </Button>
      <Button
        variant="danger"
        onClick={() => onDelete(row._id)}
      >
        Delete
      </Button>
    </>
  );

  if (isLoading) return <div>Loading...</div>;

  return <Table columns={columns} data={invoices} actions={actions} />;
};

export default InvoiceList;
